import { TreeNodeDTO } from 'business/models/Models';
import RMSvgIcon, {
  RMSvgIconProps,
} from 'components/customComponents/CommonComponents/RMSvgIcon';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import React, { useState } from 'react';
import { isNullOrUndefined, openNode } from 'utils/Global';
import './DetailRow.scss';
export type DetailRowProps = {
  backGroundClr: string;
  text: string;
  lastImaged?: string;
  startingIcon: RMSvgIconProps;
  endingIcon?: RMSvgIconProps;
  fontClr: string;
  endingIconWidthHeight?: number;
  node?: TreeNodeDTO;
  onClick?: any;
  enableDoubleClick?: any;
  isHitImageExp?: boolean;
  rowClassName?: string;
  disabled?: boolean;
  titleTip?: string;
};
export default function DetailRow(props: DetailRowProps) {
  const [openedWindows, setOpenedWindows] = useState([]);
  const route = getRoute();

  function getRoute() {
    const node = props.node;
    if (!node) {
      return null;
    }

    const { type, id, extra } = node;
    const extraId = extra?.id;

    const routesByExtraId: Record<string, string> = {
      [ETreeNodeTypes.Experiment]: `/exp/${extraId}`,
      [ETreeNodeTypes.Screen]: `/screen/${extraId}`,
      [ETreeNodeTypes.FragmentScreen]: `/fragment/${extraId}`,
      [ETreeNodeTypes.SynchrotronTripv4]: `/synchrotrontrip/${extraId}`,
      [ETreeNodeTypes.SearchAnalysis]: `/snf/${extraId}`,
    };

    const routesByNodeId: Record<string, string> = {
      [ETreeNodeTypes.Project]: `/project/${id}`,
      [ETreeNodeTypes.Protein]: `/protein/${id}`,
      [ETreeNodeTypes.Seed]: `/seed/${id}`,
    };

    const staticRoutes: Record<string, string> = {
      [ETreeNodeTypes.Search]: `/search`,
      [ETreeNodeTypes.Ingredients]: `setup/ingredients`,
      [ETreeNodeTypes.Scheduling]: `setup/imaging/scheduling`,
      [ETreeNodeTypes.CaptureProfiles]: `setup/imaging/imagingsettings`,
      [ETreeNodeTypes.Containers]: `setup/platetypes`,
      [ETreeNodeTypes.CrystalContainer]: `setup/crystalcontainer`,
      [ETreeNodeTypes.Config]: `setup/general`,
    };

    if (routesByExtraId[type]) {
      return extraId ? routesByExtraId[type] : null;
    }
    if (routesByNodeId[type]) {
      return routesByNodeId[type];
    }
    if (staticRoutes[type]) {
      return staticRoutes[type];
    }

    return null;
  }

  const onOpenNode = () => {
    const queryString = '?setAnyHitFilter=' + encodeURIComponent(true);
    const nodeId =
      props?.node?.type === ETreeNodeTypes.Protein ||
      props?.node?.type === ETreeNodeTypes.Seed
        ? props?.node?.id
        : props?.node?.extra?.id;
    const newRoute = props.isHitImageExp ? route + queryString : route;
    if (route) {
      openNode(newRoute, route, nodeId, openedWindows, setOpenedWindows);
    }
  };

  return (
    <div
      id='detailrow-wrapper'
      className={`${props.rowClassName || 'detailRow'} ${
        props.disabled || !(props.onClick || route) ? 'disabled-container' : ''
      }`}
      onClick={!isNullOrUndefined(props.onClick) ? props.onClick : () => {}}
      onDoubleClick={onOpenNode}
      title={props?.titleTip || ''}
      style={{ background: props.backGroundClr }}
    >
      <div
        id='detailrow-icon-container' 
       style={{ display: 'flex', width: '90%' }}>
        <RMSvgIcon
          id='detailrow-svg-icon'
          {...props.startingIcon}
          style={{ marginRight: 15 }}
          width="30"
          height="30"
        />
        <div id='detailrow-icon-text' className="detailRowText">
          <span id='detailrow-name' className="name">{props.text}</span>
          <span id='detailrow-last-imaged' className="last-imaged">{props.lastImaged}</span>
        </div>
      </div>
      {props.endingIcon && (
        <div
          id='detailrow-ending-icon'
          style={{
            width: '10%',
            display: 'flex',
            justifyContent: 'flex-end',
            marginRight: '5%',
          }}
        >
          <RMSvgIcon
            id='detailrow-svg-ending-icon'
            {...props.endingIcon}
            style={{ marginRight: '2%' }}
            width={props.endingIconWidthHeight ? props.endingIconWidthHeight : 30}
            height={props.endingIconWidthHeight ? props.endingIconWidthHeight : 30}
          />
        </div>
      )}
    </div>
  );
}
